import React, { useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
  Typography,
  Grid,
  Modal,
  Box,
} from "@mui/material";
import AdminSidebar from "../../Container/AdminSidebar/AdminSidebar";
import { useHistory, useNavigate } from "react-router-dom";
import TextField from '@mui/material/TextField';
import "./index.css";
import "react-quill-new/dist/quill.snow.css"; // Import Quill styles
import ReactQuill from "react-quill-new"; // Import React Quill

const PostGrid = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const [rowData, setRowData] = useState([]);
  const [Classes, setClasses] = React.useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [updatedClass, setUpdatedClass] = useState({ class_name: "", status: "" });
  const [addClassModal, setAddClassModal] = useState(false); 
  const [content, setContent] = useState("");
  const [error, setError] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


  const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // Header levels
            ["bold", "italic", "underline", "strike"], // Text styles
            [{ color: [] }, { background: [] }], // Text and background color
            [{ script: "sub" }, { script: "super" }], // Subscript/Superscript
            [{ list: "ordered" }, { list: "bullet" }], // Lists
            [{ indent: "-1" }, { indent: "+1" }], // Indent
            [{ direction: "rtl" }], // Text direction
            ["blockquote", "code-block"], // Block elements
            [{ align: [] }], // Alignment
            ["link", "image", "video"], // Media
            ["clean"], // Remove formatting
        ],
    };

  

  const closeModal = () => {
    setShowModal(false);
    setSelectedClass(null);
    setUpdatedClass({ class_name: "", status: "" });
  };

  const openAddClassModal = () => {
    setAddClassModal(true);
  };

  const closeAddClassModal = () => {
    setAddClassModal(false);
  };
  // Fetch unapproved users
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/unapproved-users`)
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  // Approve user
  const handleApprove = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to approve this user.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, approve it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .put(`${API_BASE_URL}/api/users/${id}/approve`)
          .then((response) => {
            Swal.fire("Approved!", response.data.message, "success");
            setUsers(users.filter((user) => user.id !== id));
          })
          .catch((error) => {
            Swal.fire("Error!", "Something went wrong.", "error");
            console.error("Error approving user:", error);
          });
      }
    });
  };

  const handleSave = () => {
    
    axios
      .post(`${API_BASE_URL}/api/addClass`, updatedClass)
      .then((response) => {
        //console.log("Role updated successfully:", response.data);
        closeAddClassModal();
        // Fetch roles again after updating
        axios
          .get(`${API_BASE_URL}/api/getClassInfo`)
          .then((response) => {
            setRowData(response.data);
            // Swal({
            //     title: "Class Added successfully",
            //     icon: "success",
            //     button: "OK",
            //     timer: 2000,
            // });
            navigate("/admin/class-list");
          })
          .catch((error) => {
            console.error("Error fetching Class:", error);
          });
      })
      .catch((error) => {
        console.error("Error updating Class:", error);
      });
  };

  // Reject user
  const handleReject = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to reject this user.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, reject it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .put(`${API_BASE_URL}/api/users/${id}/reject`)
          .then((response) => {
            Swal.fire("Rejected!", response.data.message, "success");
            setUsers(users.filter((user) => user.id !== id));
          })
          .catch((error) => {
            Swal.fire("Error!", "Something went wrong.", "error");
            console.error("Error rejecting user:", error);
          });
      }
    });
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f8f9fa" }}>      
      <Box sx={{ flexGrow: 1, padding: "20px" }}>
        <Typography variant="h4" gutterBottom>
           Create Post
        </Typography>

        <Button variant="secondary" style={{ float: "right", marginTop:"" }} onClick={openAddClassModal}>
           + Add
        </Button>

        <TableContainer component={Paper} elevation={3} sx={{ mt: 3 }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#f1f1f1" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Contact No</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.length > 0 ? (
                users.map((user) => (
                  <TableRow key={user.id} hover>
                    <TableCell>{user.id}</TableCell>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>{user.contact_no}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={() => handleApprove(user.id)}
                          >
                            Edit
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="error"
                            size="small"
                            onClick={() => handleReject(user.id)}
                          >
                            Delete
                          </Button>
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <Typography variant="body1" color="textSecondary">
                      No users found.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Modal
        open={addClassModal}
        onClose={closeAddClassModal}
        aria-labelledby="add-class-modal-title"
        aria-describedby="add-class-modal-description"
        disableEnforceFocus
        >
        <Box
            sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 800,
            height:500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            }}
        >
            <Typography id="add-class-modal-title" variant="h6" component="h2" gutterBottom>
            Add Post
            </Typography>
            <Box component="form" noValidate>
            <ReactQuill
                value={content}
                onChange={setContent}
                placeholder="Start typing here..."
                style={{
                    marginBottom: "89px",
                    background: "#fff",
                    borderRadius: "5px",
                    height:"142px",
                    minHeight: "200px",
                    

                }}
                modules={modules} // Add the full toolbar
            />
            {error && (
                <Typography
                    variant="body2"
                    sx={{ color: "red", mb: 2 }}
                >
                    This field is required.
                </Typography>
            )}
          
            <Box sx={{ mt: 2 }}>
                <TextField
                id="status"
                label="Status"
                select
                variant="outlined"
                fullWidth
                value={updatedClass.status}
                onChange={(e) => setUpdatedClass({ ...updatedClass, status: e.target.value })}
                SelectProps={{
                    native: true, // Enables dropdown rendering with `<option>` elements
                }}
                >
                <option value="">Select Active/Deactive</option>
                <option value="1">Active</option>
                <option value="2">Deactive</option>
                </TextField>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button variant="contained" color="primary" onClick={handleSave}>
                Submit
                </Button>
                <Button variant="outlined" color="secondary" onClick={closeAddClassModal} sx={{ ml: 2 }}>
                Close
                </Button>
            </Box>
            </Box>
        </Box>
        </Modal>   
      </Box>
    </Box>
  );
};

export default PostGrid;

